import actions from '../../actions';

// reducer.js
const initialState = {
  transcriptData: '',
  lastUpdated: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.TranscriptCsvData.DOWNLOAD_TRANSCRIPT_DATA:
      return {
        ...state
      };

    case actions.TranscriptCsvData.DOWNLOAD_TRANSCRIPT_DATA_RECEIVED:
      return {
        ...state,
        transcriptData: action.data,
        lastUpdated: Date.now()
      };

    default:
      return state;
  }
};

export default reducer;
